import React from "react";
import EasyDashboard from "./sections/easyDashboard";
import DragAndDrop from "./sections/dragAndDrop";

import ImpressiveDashboard from './sections/impressiveDashboards'

import './agileDashboards.scss'
import DataVisualization from "./sections/dataVisualization";
import LetsGo from "../connectors/letsgo"
import HyaiaWidgets from "./sections/widgets";
import SeeAction from "./sections/seeAction";
import AutoUpdate from "./sections/autoUpdate";
import FastInteraction from "./sections/fastInteraction";

export default function AgileDashboards() {
    return (
        <div className="container-agile-dashboards">
            <div className="section-easydashboard">
                <EasyDashboard />
            </div>
            <div className="section-drag-and-drop">
                <DragAndDrop />
            </div>
            <div className="section-data-visualization">
                <DataVisualization />
            </div>
            <div className="section-see-action">
                <SeeAction />
            </div>
            <div className="section-widgets">
                <HyaiaWidgets />
            </div>

            <div className="section-autoupdate">
                <AutoUpdate />
            </div>

            <div className="section-fast-interaction">
                <FastInteraction />
            </div>
            <div className="section-letsgo">
                <LetsGo />
            </div>
        </div>
    )
}